import InfoGroup from './InfoGroup';

export default InfoGroup;
